import React from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../../ui/tabs';
import SubscriptionJournal from './SubscriptionJournal';
import SubscriptionPayments from './SubscriptionPayments';
import SubscriptionTrash from './SubscriptionTrash';
import {
  ClientsDirectory,
  CompaniesDirectory,
  PartnersDirectory,
  ServicesDirectory,
} from './SubscriptionDirectories';

const AdminSubscriptionsTab = () => (
  <Tabs defaultValue="journal" className="space-y-4">
    <TabsList className="flex h-auto flex-wrap justify-start">
      <TabsTrigger value="journal">Журнал</TabsTrigger>
      <TabsTrigger value="payments">Платежи</TabsTrigger>
      <TabsTrigger value="companies">Компании</TabsTrigger>
      <TabsTrigger value="clients">Клиенты</TabsTrigger>
      <TabsTrigger value="partners">Партнёры</TabsTrigger>
      <TabsTrigger value="services">Сервисы и тарифы</TabsTrigger>
      <TabsTrigger value="trash">Корзина</TabsTrigger>
    </TabsList>
    <TabsContent value="journal"><SubscriptionJournal /></TabsContent>
    <TabsContent value="payments"><SubscriptionPayments /></TabsContent>
    <TabsContent value="companies"><CompaniesDirectory /></TabsContent>
    <TabsContent value="clients"><ClientsDirectory /></TabsContent>
    <TabsContent value="partners"><PartnersDirectory /></TabsContent>
    <TabsContent value="services"><ServicesDirectory /></TabsContent>
    <TabsContent value="trash"><SubscriptionTrash /></TabsContent>
  </Tabs>
);

export default AdminSubscriptionsTab;
